module.exports = __webpack_public_path__ + "static/media/speech.21b28118.svg";